import { Schema } from "effect";
/** Structured execution failures may retain their domain code and resource identity. */
export const HttpFailureBody = /* @__PURE__ */ (() => Schema.StructWithRest(
  Schema.Struct({ error: Schema.String }), [Schema.Record(Schema.String, Schema.MutableJson)]
))();
export const ExecutionFailureResponses = /* @__PURE__ */ (() => [400, 404, 409, 500].map(
  httpApiStatus => HttpFailureBody.annotate({ httpApiStatus })
))();
